<div class="search-container" #searchContainer>
  <div class="input-wrapper">
    <app-filter-product (searchEvent)="search($event)" (click)="openOverlayIfHasValue()"></app-filter-product>
  </div>
  @if (isOverlayOpen) {
    <div class="search-results-overlay">
      @if (filteredResults.length > 0) {
        <h6 class="odx-title-6 search-results-label" i18n="@@productList.search.searchResults">Suchergebnisse</h6>
        @for (result of filteredResults; track result) {
          <div>
            <hr />
            <app-monitoring-search-item
              [result]="result"
              [canAddToFloorplan]="result.canAddToFloorplan ?? true"
              (showGroupDetails)="showGroupDetails($event)"
              [isShownOnProductList]="true"
              (addToBom)="addToProductList($event)"
            ></app-monitoring-search-item>
          </div>
        }
      } @else {
        <div class="no-results-message" i18n="@@productList.search.noResults">Keine Suchergebnisse</div>
        <app-refresh-products-hint dataType="Produkte" i18n-dataType="@@global.products"></app-refresh-products-hint>
      }
    </div>
  }
</div>
